import React from 'react';
import { MessageCircle, Plus } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

interface ChatHeaderProps {
  onNewChat?: () => void;
  connected?: boolean;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ onNewChat, connected = true }) => {
  const { user } = useAuth();

  return (
    <div className="p-4 bg-indigo-950/90 border-b border-purple-500/20">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <h2 className="text-xl font-bold text-purple-200 flex items-center">
            <MessageCircle className="w-6 h-6 mr-2" />
            Chat Astral
          </h2>
          <span className="text-sm text-purple-200/70">
            Créditos: {user?.credits ?? 0}
          </span>
          <span
            className={`text-xs px-2 py-0.5 rounded-full ${
              connected ? 'bg-green-500/20 text-green-300' : 'bg-white/10 text-purple-200/70'
            }`}
          >
            {connected ? 'conectado' : 'reconectando…'}
          </span>
        </div>

        <div className="flex items-center space-x-2">
          {onNewChat && (
            <button
              onClick={onNewChat}
              className="p-2 hover:bg-white/10 rounded-lg transition-colors"
              title="Nova conversa"
            >
              <Plus className="w-5 h-5 text-purple-200" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};